import { render, staticRenderFns } from "./already-distribute-wait-issue.vue?vue&type=template&id=5928e4bf&scoped=true"
import script from "./already-distribute-wait-issue.vue?vue&type=script&lang=ts"
export * from "./already-distribute-wait-issue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5928e4bf",
  null
  
)

export default component.exports